module.exports = __webpack_public_path__ + "static/media/drake-computer.486a89aa.gif";